<template>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center vertical">
        <div class="col-lg-6 col-xl-5">

        <h1>Reset Password</h1>
        <div class="box">
          <b-alert :show="message !== ''" variant="success">
            Your password has been reset. Please click
            <router-link to="/login">here</router-link> to login.
          </b-alert>

          <b-alert :show="errors.raw" variant="danger">
            This reset link is no longer valid. Please click
            <router-link to="/forgot-password">here</router-link> to send a new reset link.
          </b-alert>

          <b-form @submit.prevent="reset">
            <b-form-group label="Email">
              <b-form-input
                type="email" name="email"
                required
                v-model="data.email"
                :disabled="loading"
                :state="errors.email ? false : null"
              ></b-form-input>

              <b-form-invalid-feedback v-if="errors.email">
                {{ errors.email[0] }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="New Password">
              <b-form-input
                type="password" name="new_password"
                required
                v-model="data.password"
                :disabled="loading"
                :state="errors.password ? false : null"
              ></b-form-input>

              <b-form-invalid-feedback v-if="errors.password">
                {{ errors.password[0] }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Confirm New Password">
              <b-form-input
                type="password" name="new_password"
                required
                v-model="data.passwordConfirmation"
                :disabled="loading"
              ></b-form-input>
            </b-form-group>

            <button class="btn btn-secondary btn-block btn-lg" type="submit">
              <span v-if="!loading">Reset Password</span>
              <b-spinner variant="white" small v-if="loading"></b-spinner>
            </button>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ResetPassword',
  data () {
    return {
      data: {
        token: '',
        email: '',
        password: '',
        passwordConfirmation: ''
      },
      errors: {},
      loading: false,
      message: ''
    }
  },
  mounted () {
    this.data.token = this.$route.query.token
    this.data.email = this.$route.query.email
  },
  methods: {
    reset () {
      this.loading = true
      this.message = ''

      this.$http
        .post('password/reset', {
          token: this.data.token,
          email: this.data.email,
          password: this.data.password,
          password_confirmation: this.data.passwordConfirmation
        })
        .then(
          () => {
            this.message = 'Success'
          },
          (res) => {
            this.errors = res.response.data.errors
          }
        )
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
